export enum SEARCH_TYPE {
  REPORT = 'report',
  USER = 'user',
} // TODO - move this into noteflow action or reducer
